import { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { REPORTING_STATUS } from '@/helpers/reporting';
import { prettyDate } from '@/helpers/date';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { useGetPendingReports } from '@/query/queries/reporting/useGetPendingReports';
import IconDocs from './icon_docs.svg?react';
import IconClose from './icon_close.svg';
import s from './index.module.scss';

export const ReportingWarning = () => {
  const { data: reports } = useGetPendingReports();
  const { isMainFounder } = useGetMe();
  const [show, setShow] = useState(true);
  const { t } = useTranslation('dashboard');

  if (!reports?.length || !show) return null;

  const firstReport = reports[0];
  const nextReport = reports[1];

  if (!firstReport?.id && !nextReport) return null;

  const report = firstReport?.id ? firstReport : nextReport;

  if (!report) return null;

  const isAwaiting = report.status_report === REPORTING_STATUS.AWAITING;
  const isOverdue = report.status_report === REPORTING_STATUS.OVERDUE;

  return (
    <div className={classnames(s.wrapper, isOverdue && 'overdue')}>
      <IconDocs className={s.icon} />
      <div className={s.content}>
        <div className={s.text}>
          {isAwaiting
            ? t('reporting_warning.awaiting', {
                period_from: prettyDate(report.period_from, 'MMMM'),
                period_to_month: prettyDate(report.period_to, 'MMMM'),
                period_to_year: prettyDate(report.period_to, 'YYYY'),
                due_date: prettyDate(report.due_date, 'MMMM DD'),
              })
            : isOverdue &&
              t('reporting_warning.overdue', {
                period_from: prettyDate(report.period_from, 'MMMM'),
                period_to_month: prettyDate(report.period_to, 'MMMM'),
                period_to_year: prettyDate(report.period_to, 'YYYY'),
                due_date: prettyDate(report.due_date, 'MMMM DD'),
              })}
        </div>
        {isMainFounder && report.id && (
          <MyLink href={APP_LINKS.reportingUpload(report.id)} className={s.btn_upload}>
            {t('reporting_warning.upload_files')}
          </MyLink>
        )}
      </div>
      <button type="button" className={s.btn_close} onClick={() => setShow(false)}>
        <img src={IconClose} alt="close" width={24} height={24} />
      </button>
    </div>
  );
};
